<template>
  <v-layout>
    <v-flex>
      <v-row align="center" no-gutters>
        <v-col class="text-left ml-n6" cols="12" md="6">
          <v-breadcrumbs :items="subNavs"></v-breadcrumbs>
        </v-col>
        <v-col class="text-right"  cols="12" md="6">
          <ActionButtons
            @doClose="doClose"
            :actionBtnSettings="actionBtnSettings"
          >
          </ActionButtons>
        </v-col>
      </v-row>

      <v-card class="pa-6 mt-3">
        <v-card-title>
          {{ forUpdate ? 'Update' : 'Create New' }} Booking
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="text--primary mt-6">
          <AlertMessage :alerMessage="alerMessage"></AlertMessage>
          <v-row>
            <v-col cols="12" class="mb-4">
              <v-radio-group
                v-model="shipmentType"
                row
                hide-details
              >
                <template v-slot:label>
                  <div class="mr-1">Shipment Type:</div>
                </template>
                <v-radio
                  label="Sea"
                  value="1"
                >
                  <template v-slot:label>
                    <div><v-icon size="24">mdi-ferry</v-icon> Sea</div>
                  </template>
                </v-radio>
                <v-radio
                  label="Air Freight"
                  value="2"
                  class="ml-5"
                >
                  <template v-slot:label>
                    <div><v-icon size="24">mdi-airplane</v-icon> Air Freight</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="5">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="booking.client"
                    label="Bill To"
                    hide-details
                    outlined
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="!hideWarehouses">
                  <v-select
                    v-model="booking.origin_warehouse"
                    :items="overseasWarehouses"
                    menu-props="auto"
                    label="Origin Warehouse"
                    item-text="name"
                    item-value="id"
                    outlined
                    hide-details
                    :disabled="booking.origin_warehouse == ''"
                  ></v-select>
                </v-col>
                <v-col cols="12" v-if="!hideWarehouses">
                  <v-select
                    v-model="booking.destination_warehouse"
                    :items="warehouses"
                    menu-props="auto"
                    label="Destination Warehouse"
                    item-text="name"
                    item-value="id"
                    outlined
                    hide-details
                    :disabled="booking.destination_warehouse == ''"
                  ></v-select>
                </v-col>


              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="5" offset-md="2">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="booking.created_date"
                    label="Created Date"
                    hide-details
                    outlined
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-menu
                      v-model="menuEstDeliveryDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="booking.target_delivery_date"
                          label="Estimated Delivery Date"
                          append-icon="mdi-calendar"
                          readonly
                          outlined
                          hide-details
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="booking.target_delivery_date"
                        @input="menuEstDeliveryDate = false"
                        :min="booking.created_date"
                      ></v-date-picker>
                    </v-menu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-sheet
            v-if="shipmentType"
            rounded
            class="pa-5 px-6 pb-7 mt-12"
            color="#f3f3f3">

            <v-data-table
              :headers="headers"
              :items="items"
              class="item-data-input"
              :loading="loading"
              :items-per-page="1000"
              hide-default-footer
              loading-text="Loading Items..."
              no-data-text="No Items"
              ref="table">

              <template v-slot:item.description="props">
                <v-text-field
                  class="bg-white"
                  v-model="props.item.description"
                  placeholder="Description"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.qty="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.qty"
                  @focus="$event.target.select()"
                  placeholder="Qty"
                  dense
                  outlined
                  @keypress="filter($event)"
                  hide-details
                ></v-text-field>
              </template>
              <template v-slot:item.item_length="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.item_length"
                  @focus="$event.target.select()"
                  placeholder="Length"
                  @keypress="filter($event)"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <template v-slot:item.item_width="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.item_width"
                  @focus="$event.target.select()"
                  placeholder="Width"
                  @keypress="filter($event)"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <template v-slot:item.item_height="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.item_height"
                  @focus="$event.target.select()"
                  placeholder="Height"
                  @keypress="filter($event)"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.cbm="props">
                <v-text-field
                  class="centered-input bg-white"
                  placeholder="CBM"
                  dense
                  :value="formatNumber(computeCBM(props.item))"
                  outlined
                  disabled
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.kg="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.kg"
                  @focus="$event.target.select()"
                  placeholder="KG"
                  @keypress="filter($event)"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </template>


              <template v-slot:item.action="{ item }">
                <v-icon
                  color=" darken-2"
                  @click="deleteItem(item)">
                  mdi-close
                </v-icon>
              </template>

              <template v-slot:body.append>
                <tr>
                  <td class="text-center" :colspan="forSea ? 8 : 6">
                    <div class="mt-4">
                          <v-btn
                            fab
                            dark
                            small
                            depressed
                            color="primary"
                            class="mb-1"
                            @click="addMoreItems()"
                          >
                            <v-icon dark>
                              mdi-plus
                            </v-icon>
                          </v-btn>
                          <br>
                          <span class="primary-color font-weight-medium">Add Item</span>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-sheet>

          <v-checkbox v-model="isAgree" hide-details class="pt-6">
            <template v-slot:label>
              <div>
                By clicking here, I state that I have read and understood the <a href="#" @click.stop="termsDialog.show = true" class="text-decoration-none">terms and conditions</a>.                
              </div>
            </template>
          </v-checkbox>
        </v-card-text>
        <v-card-actions class="ml-2 my-2">
          <v-btn
            color="primary"
            depressed
            large
            :disabled="!isAgree"
            @click="submit()">
            <span v-if="loading" class="mx-4">Please wait...</span>
            <span v-if="!loading" class="mx-4">Create Booking</span>
          </v-btn>

          <v-btn
            depressed
            large
            :to="{ name: 'bookings' }"
            class="ml-4"
          >
            <span class="mx-4">Cancel</span>
          </v-btn>
        </v-card-actions>

      </v-card>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
      <InsuranceTermsDialog :dialog="termsDialog" @doConfirm="submit()" @doCancel="termsDialog.show = false" />
      <ConfirmationDialog
        :dialog="dialog"
        @doConfirm="doConfirm"
        @doCancel="doCancel"
      >
      </ConfirmationDialog>
      <Loader :loading="loading"></Loader>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from "vuex";
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import Loader from '@/components/Loader.vue'
  import ConfirmationDialog from '@/components/dialog/ConfirmationDialog.vue'
  import InsuranceTermsDialog from '@/components/InsuranceTermsDialog.vue'
  import AlertMessage from '@/components/AlertMessage.vue'
  import ActionButtons from '@/components/ActionButtons.vue'

  export default {
    name: 'ClientBookingCreateNew',
    data: () => ({
      id: null,
      isAgree: false,
      shipmentType: '',
      shipmentTypeLabel: '',
      loading: false,
      menuEstDeliveryDate: false,
      perPage: 2000,
      client: null,
      clients: [],
      hideWarehouses: true,
      warehouses: [],
      overseasWarehouses: [],
      search: '',
      awaitingSearch: false,
      actionBtnSettings: {
        edit: 0,
        save: 0,
        close: 1,
        print: 0,
        refresh: 0,
        save_and_print: 0,
        save_disabled: true,
        close_disabled: false,
        print_disabled: false,
        save_and_print_disabled: true
      },
      termsDialog: {
        show: false
      },
      dialog: {
        show: false,
        title: 'Delete Item',
        body: 'Are you sure you want to delete this item?',
        type: '',
        item: {},
        confirmBtn: 'Yes',
        cancelBtn: 'Cancel'
      },
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      subNavs: [
        {
          text: 'Bookings',
          disabled: false,
          exact: true,
          to: {
            name: 'bookings'
          },
        },
        {
          text: 'Create New Booking',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      error:{
        show: false,
        status: '',
        error: '',
        messages: {}
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      booking: {
        id: '',
        client: '',
        destination_warehouse: '',
        origin_warehouse: '',
        sales_agent: '',
        shipment_type: '',
        created_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        target_delivery_date: '',
        items: []
      },
      items: [],
      headers: []
    }),
    computed: {
      ...mapGetters(['formatNumber', 'getCurrentUser', 'getFullname', 'formatNumberAmount', 'formatNumberAmountNoComma']),
      forUpdate: function(){
        return this.id ? true : false
      },
      forSea: function(){
        return this.shipmentType == this.$getConstShipmentType('SHIPMENT_TYPE_SEA') ? true : false
      }
    },
    watch: {
      shipmentType: function (val) {
        if(val == this.$getConstShipmentType('SHIPMENT_TYPE_SEA')){
          this.shipmentTypeLabel = 'CBM'
          this.hideWarehouses = false
          this.headers = [
            {
              text: 'Item',
              align: 'start',
              value: 'description',
              sortable: false
            },
            {
              text: 'Qty',
              align: 'center',
              value: 'qty',
              sortable: false,
              width: 100
            },
            {
              text: 'KG',
              align: 'center',
              value: 'kg',
              sortable: false,
              width: 100
            },
            {
              text: 'Length',
              align: 'center',
              value: 'item_length',
              sortable: false,
              width: 100
            },
            {
              text: 'Width',
              align: 'center',
              value: 'item_width',
              sortable: false,
              width: 100
            },
            {
              text: 'Height',
              align: 'center',
              value: 'item_height',
              sortable: false,
              width: 100
            },
            {
              text: 'CBM',
              align: 'center',
              value: 'cbm',
              sortable: false,
              width: 120
            },
            {
              text: 'Action',
              value: 'action',
              align: 'center',
              sortable: false,
              width: 50
            }
          ]
        }else if(val == this.$getConstShipmentType('SHIPMENT_TYPE_AIRFREIGHT')){
          this.shipmentTypeLabel = 'KG'
          this.hideWarehouses = true
          this.headers = [
            {
              text: 'Item',
              align: 'start',
              value: 'description',
              sortable: false
            },
            {
              text: 'Qty',
              align: 'center',
              value: 'qty',
              sortable: false,
              width: 180
            },
            {
              text: 'KG',
              align: 'center',
              value: 'kg',
              sortable: false,
              width: 180
            },
            {
              text: 'Action',
              value: 'action',
              align: 'center',
              sortable: false,
              width: 70
            }
          ]
        }

      }
    },
    methods: {
      scrollToElement (element, body) {
        this.$scrollTo(
          element,
          500,
          {
            container: body,
            easing: 'ease-in',
            lazy: false,
            offset: -100,
            force: true,
            cancelable: true,
            onStart: function(element) {
              // scrolling started
            },
            onDone: function(element) {
              // scrolling is done
            },
            onCancel: function() {
              // scrolling has been interrupted
            },
            x: false,
            y: true
          }
        )
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get('/default-data?warehouses=true&overseaswarehouses=true')
          .then(response => {
            this.warehouses = response.data.warehouses
            this.warehouses.shift()
            this.overseasWarehouses = response.data.overseaswarehouses
          })
          .catch(error => {
            console.log(error);
          })
      },
      computeCBM (item){
        let totalCBM = (Number(this.formatNumberAmountNoComma(this.$numeral, item.item_length)) *
          Number(this.formatNumberAmountNoComma(this.$numeral, item.item_width)) *
          Number(this.formatNumberAmountNoComma(this.$numeral, item.item_height))) / 1000000

        return Number(this.formatNumberAmountNoComma(this.$numeral, item.qty)) * totalCBM
      },
      filter: function(evt) {
        evt = (evt) ? evt : window.event;
        let expect = evt.target.value.toString() + evt.key.toString();

        if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      doClose (){
        this.cancelBooking()
      },
      cancelBooking() {
        this.dialog = {
          show: true,
          title: 'Cancel Booking',
          body: 'Are you sure you want to cancel this booking?',
          type: 'close',
          item: {},
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      doConfirm () {
        this.dialog.show = false

        if(this.dialog.type == 'close'){
          this.$router.push({ name: 'bookings' })
        }else{
          this.items.splice(this.items.indexOf(this.dialog.item), 1)
          if(this.dialog.item.description.length > 0){
            this.showMessage(this.dialog.item.description + " has been successfully deleted", 'success')
          }
        }
      },
      doCancel () {
        this.dialog.show = false
      },
      deleteItem (item) {
        if(item.description.length == 0){
          this.items.splice(this.items.indexOf(item), 1)
          return false
        }
        this.dialog = {
          show: true,
          title: 'Delete Item',
          body: 'Are you sure you want to delete '+item.description+' item?',
          type: 'item',
          item: item,
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      addMoreItems(){
        this.items.push(
          { description: '', qty: '', cbm: '', kg: '', item_length: '', item_width: '', item_height: '' }
        )
      },
      generateItemRows() {
        for (let i = 0; i < 5; i++) {
          this.items.push(
            { description: '', qty: '', cbm: '', kg: '', item_length: '', item_width: '', item_height: '' }
          )
        }
      },
      getBooking () {
        this.loading = true
        let self = this
        this.$http.plain.get('bookings/'+this.id)
          .then(response => {
            this.booking = response.data
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
      },
      addNew () {
        let self = this
        this.booking.shipment_type = this.shipmentType
        this.booking.items = this.items
        this.$http.secured.post('bookings', this.booking)
          .then(response => {
            this.$router.push({ name: 'booking-view', params: { id: response.data } })
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
            this.scrollToElement('body', 'body')
          })
          .then(function () {
            self.loading = false
          })
      },
      async submit () {
        this.termsDialog.show = false
        this.alerMessage.show = false

        if(this.loading){
          return false;
        }

        this.loading = true

        this.addNew()
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      }
    },
    mounted() {
      this.generateItemRows()
      this.booking.client = this.getFullname
      this.booking.sales_agent = this.getCurrentUser.sales_agent
      this.booking.destination_warehouse = this.getCurrentUser.warehouse_id
      this.booking.origin_warehouse = this.getCurrentUser.location_id
      this.getDefaultData()
    },
    components: {
      ActionButtons,
      AlertMessage,
      SnackBar,
      ConfirmationDialog,
      Loader,
      InsuranceTermsDialog
    }
  }
</script>
